import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, of } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import { IPendingUserInvitationResponse } from 'src/app/models/pending-user-invitation.response';

@Component({
  selector: 'app-workspace-invitation',
  templateUrl: './workspace-invitation.component.html',
  styleUrls: ['./workspace-invitation.component.css'],
})
export class WorkspaceInvitationComponent implements OnInit {
  public item: IPendingUserInvitationResponse | null = null;
  public processing: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<WorkspaceInvitationComponent>,
    private api: ApiService,
    private snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.item = this.data;
    if (!this.item) this.dialog.close();
  }

  acceptInvitation() {
    if (this.item) {
      this.processing = true;
      this.api
        .getAcceptInvitation(this.item.public_id)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.error?.message) {
              this.snack.open(err.error.message, undefined, {
                duration: 4000,
                panelClass: 'errorSnackbar',
              });
            } else if (err.error?.error) {
              this.snack.open(err.error.error, undefined, {
                duration: 4000,
                panelClass: 'errorSnackbar',
              });
            } else if (err.error) {
              this.snack.open(err.error, undefined, {
                duration: 4000,
                panelClass: 'errorSnackbar',
              });
            } else {
              this.snack.open(
                'An error occurred while accepting the workspace invitation.',
                'dismiss',
                { duration: 4000, panelClass: 'errorSnackbar' }
              );
            }
            return of(null);
          })
        )
        .subscribe((val) => {
          this.processing = false;
          if (val) {
            this.dialog.close('accepted');
            this.snack.open(val.message, undefined, {
              duration: 4000,
              panelClass: 'successSnackbar',
            });
          }
        });
    }
  }

  rejectInvitation() {
    if (this.item) {
      this.processing = true;
      this.api
        .getDeclineInvitation(this.item.public_id)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.error?.message) {
              this.snack.open(err.error.message, undefined, {
                duration: 4000,
                panelClass: 'errorSnackbar',
              });
            } else if (err.error?.error) {
              this.snack.open(err.error.error, undefined, {
                duration: 4000,
                panelClass: 'errorSnackbar',
              });
            } else if (err.error) {
              this.snack.open(err.error, undefined, {
                duration: 4000,
                panelClass: 'errorSnackbar',
              });
            } else {
              this.snack.open(
                'An error occurred while rejecting the workspace invitation.',
                'dismiss',
                { duration: 4000, panelClass: 'errorSnackbar' }
              );
            }
            return of(null);
          })
        )
        .subscribe((val) => {
          this.processing = false;
          if (val) {
            this.dialog.close('rejected');
            this.snack.open(val.message, undefined, {
              duration: 4000,
              panelClass: 'successSnackbar',
            });
          }
        });
    }
  }
}
